import React, { useState } from "react";
import "./gemeinde.styles.scss";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import FormInput from "../form-inputs/form-input.component";
import { selectCurrentUser } from "../../redux/user/user.selector";
import {
  selectGemeinde,
  selectErntehelfer,
} from "../../redux/gemeinde/gemeinde.selector";
import GemeindeMitglieder from "../gemeinde/gemeindemitglieder.component";
import CustomButton from "../form-inputs/custom-button.component";
import { registerNewErntehelfer } from "../../redux/user/user.actions";
import { Typography } from "@material-ui/core";
const GemeindeComponent = ({
  currentUser,
  gemeinde,
  registerNewErntehelfer,
  erntehelfer,
}) => {
  const [userCredentials, setCredentials] = useState({
    email: "",
    displayName: "",
  });
  const [showForm, setShowForm] = useState(false);
  const { email, displayName } = userCredentials;
  const handleSubmit = async (event) => {
    event.preventDefault();
    registerNewErntehelfer({
      email,
      displayName,
      gemeindeId: gemeinde.id,
    });
    setCredentials({ email: "", displayName: "" });
    setShowForm(false);
  };

  const handleChange = (event) => {
    const { value, name } = event.target;
    setCredentials({ ...userCredentials, [name]: value });
  };
  return (
    <div className="gemeindecomponent">
      <Typography variant="h5" paragraph="true">
        {gemeinde.name}
      </Typography>
      <div className="adresse">
        <Typography variant="body1">{gemeinde.strasse}</Typography>
        <Typography variant="body1" paragraph="true">
          {gemeinde.plz + " " + gemeinde.ort}{" "}
        </Typography>
        {currentUser && currentUser.isSaemann ? (
          <Typography variant="body1">
            Sie sind der Sämann dieser Gemeinde
          </Typography>
        ) : (
          <Typography variant="body1">
            Sie sind ein Erntehelfer dieser Gemeinde
          </Typography>
        )}
      </div>
      <br />
      <Typography variant="h5">Sämänner und Erntehelfer:</Typography>
      <GemeindeMitglieder />
      {currentUser.isSaemann && erntehelfer.length < 11 ? (
        <CustomButton onClick={() => setShowForm(!showForm)}>
          {showForm ? "- " : "+ "}Erntehelfer hinzufügen
        </CustomButton>
      ) : null}
      {showForm ? (
        <form onSubmit={handleSubmit}>
          <FormInput
            name="email"
            type="email"
            value={email}
            handleChange={handleChange}
            required
            label="Email"
          />
          <FormInput
            name="displayName"
            type="text"
            value={userCredentials.displayName}
            handleChange={handleChange}
            required
            label="Name"
          />
          <CustomButton type="Submit">Einladung versenden</CustomButton>
        </form>
      ) : null}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  registerNewErntehelfer: (userData) =>
    dispatch(registerNewErntehelfer(userData)),
});

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  gemeinde: selectGemeinde,
  erntehelfer: selectErntehelfer,
});

export default connect(mapStateToProps, mapDispatchToProps)(GemeindeComponent);
